<template>
  <div
    id="data-list-list-view"
    class="mt-3 data-list-container flipthis-highlight vs-con-loading__container"
  >
    <vs-table
      ref="table"
      :sst="true"
      :data="usuarios"
      @sort="handleOrdenacao"
      noDataText="Nenhum dado disponível com os filtros selecionados."
    >
      <template slot="thead" v-if="usuarios.length">
        <vs-th sort-key="id">#</vs-th>
        <vs-th sort-key="nome">Nome completo</vs-th>
        <vs-th sort-key="cpf">CPF</vs-th>
        <vs-th sort-key="updated_at">Tipo de usuário</vs-th>
        <vs-th v-if="todasAsAssociacoes && todasAsEntidades" sort-key="updated_at">Associação</vs-th>
        <vs-th v-if="todasAsEntidades" sort-key="updated_at">Entidade</vs-th>
        <vs-th></vs-th>
      </template>

      <template>
        <tbody>
          <vs-tr :data="usuario" :key="indextr" v-for="(usuario, indextr) in usuarios">
            <vs-td>
              <p class="product-name font-medium main-menu-sidebar">{{ usuario.id }}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-semibold main-menu-sidebar">{{ usuario.nome }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category main-menu-sidebar">{{ usuario.cpf }}</p>
            </vs-td>
            <vs-td>
              <p
                class="product-category main-menu-sidebar"
              >{{ usuario.usuarioTipo ? usuario.usuarioTipo.nome : '' }}</p>
            </vs-td>
            <vs-td v-if="todasAsAssociacoes">
              <p
                class="product-category main-menu-sidebar"
              >{{ usuario.associacao ? usuario.associacao.nome : '' }}</p>
            </vs-td>
            <vs-td v-if="todasAsEntidades">
              <p
                class="product-category main-menu-sidebar"
              >{{ usuario.entidade ? usuario.entidade.nome : '' }}</p>
            </vs-td>
            <vs-td>
              <div class="text-right">
                <vs-dropdown class="cursor-pointer" vs-custom-content vs-trigger-click>
                  <vs-button
                    class="btn-drop"
                    icon="more_vert"
                    radius
                    size="small"
                    color="#c3c3c3"
                    type="border"
                  ></vs-button>
                  <vs-dropdown-menu>
                    <vs-dropdown-item
                      :to="{name: 'visualizar-usuario', params: { id: usuario.id }}"
                    >Visualizar</vs-dropdown-item>
                    <vs-dropdown-item
                      :to="{name: 'gerenciar-usuario', params: { id: usuario.id }}"
                    >Gerenciar</vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <paginacao :meta="meta" :handler="handlePaginaSelecionada" />
  </div>
</template>

<script>
export default {
  name: "usuarios-paginacao",
  created() {
    this.$store.dispatch("RESET_USUARIOS");
    this.buscarUsuarios(1);
  },
  watch: {
    $route(to) {
      this.buscarUsuarios(to.query.page);
    },
    loading(loading) {
      if (loading) {
        this.$vs.loading({
          container: "#data-list-list-view",
          scale: 0.6
        });
      } else {
        this.$vs.loading.close("#data-list-list-view > .con-vs-loading");
      }
    }
  },
  computed: {
    loading() {
      return this.$store.getters.isUsuariosLoading();
    },
    usuarios() {
      return this.$store.getters.getUsuarios();
    },
    meta() {
      return this.$store.getters.getUsuariosMeta();
    }
  },
  methods: {
    buscarUsuarios(page) {
      this.$store.dispatch("FETCH_USUARIOS", {
        page: page,
        ...this.$route.query
      });
    },
    handlePaginaSelecionada(query) {
      this.$router.push({
        name: "usuarios",
        query
      });
    },
    handleOrdenacao(key, active) {
      this.$router.push({
        name: "usuarios",
        query: {
          ...this.$route.query,
          sortedBy: active ? "asc" : "desc",
          orderBy: key,
          page: 1
        }
      });
    }
  }
};
</script>
